var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategorySushi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_8205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.73 17.7303H60.6142V50.353C60.6142 69.5521 145.73 69.5521 145.73 50.353V17.7303H145.73Z",
    fill: "url(#paint0_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.729 17.7303C145.729 36.9294 60.6132 36.9294 60.6132 17.7303C60.6132 -1.46885 145.729 -1.46885 145.729 17.7303Z",
    fill: "url(#paint1_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.928 16.1824C127.928 13.0621 122.112 11.0112 114.467 10.0298C99.8057 8.14741 82.9557 10.1983 82.9557 16.1824C82.9557 19.5374 85.1386 21.6562 93.6307 22.5386C108.183 24.0506 127.928 21.9318 127.928 16.1824Z",
    fill: "url(#paint2_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.72 22.005C110.755 20.5791 106.42 16.2764 106.42 11.1894C106.42 10.5847 106.483 9.99172 106.6 9.4126C117.736 9.79524 127.928 12.0517 127.928 16.1823C127.928 18.9879 123.225 20.9285 116.72 22.005Z",
    fill: "url(#paint3_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.603 10.0476C113.54 13.8994 107.699 16.8453 100.65 16.8453C94.1089 16.8453 88.608 14.3073 87.0009 10.8629C94.6068 9.17528 105.831 8.90352 114.603 10.0476Z",
    fill: "url(#paint4_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4151 16.1823C78.4151 12.9196 84.7739 10.8264 92.9339 9.90226C96.5489 9.49285 99.8992 12.139 100.115 15.7708C100.123 15.8999 100.127 16.0296 100.127 16.1599C100.127 16.8184 100.028 17.4596 99.8407 18.0764C98.9524 21.004 96.0033 22.8084 92.9636 22.4652C84.7892 21.5431 78.4151 19.449 78.4151 16.1823Z",
    fill: "url(#paint5_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.493 19.4552C111.933 16.5464 115.458 15.3555 118.367 16.7952L124.537 19.8493C121.751 21.1479 117.484 22.0464 112.65 22.5449C110.963 22.7185 109.741 20.9749 110.493 19.4552Z",
    fill: "url(#paint6_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M69.2544 16.6645C70.1076 16.6645 70.7994 15.9727 70.7994 15.1195C70.7994 14.2662 70.1076 13.5745 69.2544 13.5745C68.4011 13.5745 67.7094 14.2662 67.7094 15.1195C67.7094 15.9727 68.4011 16.6645 69.2544 16.6645Z",
    fill: "url(#paint7_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M70.433 21.1139C71.1066 21.1139 71.6527 20.5678 71.6527 19.8941C71.6527 19.2205 71.1066 18.6744 70.433 18.6744C69.7594 18.6744 69.2133 19.2205 69.2133 19.8941C69.2133 20.5678 69.7594 21.1139 70.433 21.1139Z",
    fill: "url(#paint8_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.6616 17.2481C75.0677 17.2481 75.3969 16.9189 75.3969 16.5128C75.3969 16.1067 75.0677 15.7775 74.6616 15.7775C74.2555 15.7775 73.9263 16.1067 73.9263 16.5128C73.9263 16.9189 74.2555 17.2481 74.6616 17.2481Z",
    fill: "url(#paint9_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M132.862 21.7644C133.715 21.7644 134.407 21.0727 134.407 20.2194C134.407 19.3662 133.715 18.6744 132.862 18.6744C132.009 18.6744 131.317 19.3662 131.317 20.2194C131.317 21.0727 132.009 21.7644 132.862 21.7644Z",
    fill: "url(#paint10_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M129.993 25.4342C130.667 25.4342 131.213 24.8881 131.213 24.2145C131.213 23.5408 130.667 22.9948 129.993 22.9948C129.32 22.9948 128.773 23.5408 128.773 24.2145C128.773 24.8881 129.32 25.4342 129.993 25.4342Z",
    fill: "url(#paint11_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.309 25.9732C135.715 25.9732 136.045 25.6439 136.045 25.2379C136.045 24.8318 135.715 24.5026 135.309 24.5026C134.903 24.5026 134.574 24.8318 134.574 25.2379C134.574 25.6439 134.903 25.9732 135.309 25.9732Z",
    fill: "url(#paint12_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.44 10.8C76.0704 10.8 76.5815 10.289 76.5815 9.65856C76.5815 9.02814 76.0704 8.51709 75.44 8.51709C74.8096 8.51709 74.2985 9.02814 74.2985 9.65856C74.2985 10.289 74.8096 10.8 75.44 10.8Z",
    fill: "url(#paint13_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.3914 13.5615C73.8891 13.5615 74.2925 13.158 74.2925 12.6603C74.2925 12.1626 73.8891 11.7592 73.3914 11.7592C72.8936 11.7592 72.4902 12.1626 72.4902 12.6603C72.4902 13.158 72.8936 13.5615 73.3914 13.5615Z",
    fill: "url(#paint14_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M77.3366 13.8663C77.6366 13.8663 77.8798 13.623 77.8798 13.323C77.8798 13.023 77.6366 12.7798 77.3366 12.7798C77.0365 12.7798 76.7933 13.023 76.7933 13.323C76.7933 13.623 77.0365 13.8663 77.3366 13.8663Z",
    fill: "url(#paint15_linear_465_8205)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M112.025 64.4714L84.3753 36.8217C80.6241 32.4414 71.5044 29.5288 60.6135 28.0829V50.3532C60.6132 61.2926 88.2479 65.9985 112.025 64.4714Z",
    fill: "url(#paint16_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2116 41.4119H1.0957V74.0345C1.0957 93.2336 86.2116 93.2336 86.2116 74.0345V41.4119Z",
    fill: "url(#paint17_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2116 41.4119C86.2116 60.611 1.0957 60.611 1.0957 41.4119C1.0957 22.2128 86.2116 22.2131 86.2116 41.4119Z",
    fill: "url(#paint18_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8973 39.8643C18.8973 36.7499 24.6911 34.7008 32.3149 33.7173C46.9779 31.8252 63.9864 33.8743 63.9864 39.8643C63.9864 43.1629 61.9114 45.2664 53.6226 46.1746C39.0326 47.7737 18.8973 45.6702 18.8973 39.8643Z",
    fill: "url(#paint19_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1055 45.687C36.0708 44.2611 40.4055 39.9584 40.4055 34.8714C40.4055 34.2667 40.3429 33.6737 40.2249 33.0946C29.0893 33.4773 18.8973 35.7337 18.8973 39.8643C18.8973 42.6696 23.5996 44.6105 30.1055 45.687Z",
    fill: "url(#paint20_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2221 33.7296C33.285 37.5814 39.1262 40.5273 46.1745 40.5273C52.7159 40.5273 58.2168 37.9893 59.8239 34.5449C52.2183 32.857 40.9939 32.5855 32.2221 33.7296Z",
    fill: "url(#paint21_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41 39.8643C68.41 36.6016 62.0512 34.5084 53.8912 33.5843C50.2762 33.1749 46.9259 35.821 46.71 39.4528C46.7024 39.5819 46.6985 39.7116 46.6985 39.8419C46.6985 40.5004 46.7974 41.1416 46.9844 41.7584C47.8727 44.686 50.8218 46.4904 53.8615 46.1472C62.0359 45.2248 68.41 43.1307 68.41 39.8643Z",
    fill: "url(#paint22_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3317 43.137C34.8919 40.2282 31.3667 39.0373 28.4578 40.477L22.2875 43.5311C25.0743 44.8296 29.3405 45.7282 34.1752 46.2267C35.8617 46.4002 37.084 44.6567 36.3317 43.137Z",
    fill: "url(#paint23_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.73653 40.346C10.5898 40.346 11.2815 39.6543 11.2815 38.801C11.2815 37.9477 10.5898 37.256 9.73653 37.256C8.88325 37.256 8.19153 37.9477 8.19153 38.801C8.19153 39.6543 8.88325 40.346 9.73653 40.346Z",
    fill: "url(#paint24_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.9155 44.7954C11.5891 44.7954 12.1352 44.2493 12.1352 43.5757C12.1352 42.902 11.5891 42.356 10.9155 42.356C10.2419 42.356 9.6958 42.902 9.6958 43.5757C9.6958 44.2493 10.2419 44.7954 10.9155 44.7954Z",
    fill: "url(#paint25_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.1437 40.9296C15.5498 40.9296 15.879 40.6004 15.879 40.1943C15.879 39.7882 15.5498 39.459 15.1437 39.459C14.7376 39.459 14.4084 39.7882 14.4084 40.1943C14.4084 40.6004 14.7376 40.9296 15.1437 40.9296Z",
    fill: "url(#paint26_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.3444 45.4463C74.1977 45.4463 74.8894 44.7546 74.8894 43.9013C74.8894 43.048 74.1977 42.3563 73.3444 42.3563C72.4912 42.3563 71.7994 43.048 71.7994 43.9013C71.7994 44.7546 72.4912 45.4463 73.3444 45.4463Z",
    fill: "url(#paint27_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M70.4761 49.116C71.1497 49.116 71.6958 48.57 71.6958 47.8963C71.6958 47.2227 71.1497 46.6766 70.4761 46.6766C69.8024 46.6766 69.2563 47.2227 69.2563 47.8963C69.2563 48.57 69.8024 49.116 70.4761 49.116Z",
    fill: "url(#paint28_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.7922 49.6548C76.1983 49.6548 76.5275 49.3256 76.5275 48.9195C76.5275 48.5134 76.1983 48.1842 75.7922 48.1842C75.3861 48.1842 75.0569 48.5134 75.0569 48.9195C75.0569 49.3256 75.3861 49.6548 75.7922 49.6548Z",
    fill: "url(#paint29_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.9222 34.4819C16.5526 34.4819 17.0636 33.9709 17.0636 33.3404C17.0636 32.71 16.5526 32.199 15.9222 32.199C15.2918 32.199 14.7807 32.71 14.7807 33.3404C14.7807 33.9709 15.2918 34.4819 15.9222 34.4819Z",
    fill: "url(#paint30_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.8735 37.2434C14.3712 37.2434 14.7747 36.8399 14.7747 36.3422C14.7747 35.8445 14.3712 35.441 13.8735 35.441C13.3758 35.441 12.9724 35.8445 12.9724 36.3422C12.9724 36.8399 13.3758 37.2434 13.8735 37.2434Z",
    fill: "url(#paint31_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.8187 37.5478C18.1188 37.5478 18.362 37.3046 18.362 37.0045C18.362 36.7045 18.1188 36.4613 17.8187 36.4613C17.5187 36.4613 17.2755 36.7045 17.2755 37.0045C17.2755 37.3046 17.5187 37.5478 17.8187 37.5478Z",
    fill: "url(#paint32_linear_465_8205)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M151.096 65.0942H65.9798V97.7169C65.9798 116.916 151.096 116.916 151.096 97.7169V65.0942Z",
    fill: "url(#paint33_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.096 65.0942C151.096 84.2933 65.9798 84.2933 65.9798 65.0942C65.9798 45.895 151.096 45.895 151.096 65.0942Z",
    fill: "url(#paint34_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7814 63.5462C83.7814 66.6638 89.5875 68.7141 97.2234 69.6965C111.886 71.5829 130.322 69.5329 130.322 63.5462C130.322 60.1544 126.422 58.0262 117.798 57.1615C103.274 55.7053 83.7814 57.8335 83.7814 63.5462Z",
    fill: "url(#paint35_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9896 57.7235C100.955 59.1494 105.29 63.452 105.29 68.5391C105.29 69.1438 105.227 69.7368 105.109 70.3159C93.9734 69.9332 83.7814 67.6768 83.7814 63.5462C83.7814 60.7406 88.484 58.8 94.9896 57.7235Z",
    fill: "url(#paint36_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1062 69.681C98.1691 65.8292 104.01 62.8833 111.059 62.8833C117.6 62.8833 123.101 65.4212 124.708 68.8657C117.102 70.5533 105.878 70.8251 97.1062 69.681Z",
    fill: "url(#paint37_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.294 63.5462C133.294 66.8088 126.936 68.9021 118.776 69.8262C115.161 70.2356 111.81 67.5894 111.594 63.9576C111.587 63.8285 111.583 63.6988 111.583 63.5685C111.583 62.91 111.682 62.2688 111.869 61.6521C112.757 58.7244 115.706 56.92 118.746 57.2632C126.92 58.1853 133.294 60.2797 133.294 63.5462Z",
    fill: "url(#paint38_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.859 60.2732C117.299 63.182 120.824 64.3729 123.733 62.9332L129.904 59.8791C127.117 58.5806 122.851 57.682 118.016 57.1835C116.329 57.01 115.107 58.7538 115.859 60.2732Z",
    fill: "url(#paint39_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.6206 64.0282C75.4739 64.0282 76.1656 63.3365 76.1656 62.4832C76.1656 61.6299 75.4739 60.9382 74.6206 60.9382C73.7673 60.9382 73.0756 61.6299 73.0756 62.4832C73.0756 63.3365 73.7673 64.0282 74.6206 64.0282Z",
    fill: "url(#paint40_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.7996 68.4776C76.4732 68.4776 77.0193 67.9315 77.0193 67.2579C77.0193 66.5843 76.4732 66.0382 75.7996 66.0382C75.126 66.0382 74.5799 66.5843 74.5799 67.2579C74.5799 67.9315 75.126 68.4776 75.7996 68.4776Z",
    fill: "url(#paint41_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.0278 64.6118C80.4339 64.6118 80.7631 64.2826 80.7631 63.8765C80.7631 63.4704 80.4339 63.1412 80.0278 63.1412C79.6217 63.1412 79.2925 63.4704 79.2925 63.8765C79.2925 64.2826 79.6217 64.6118 80.0278 64.6118Z",
    fill: "url(#paint42_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M138.229 69.1282C139.082 69.1282 139.774 68.4365 139.774 67.5832C139.774 66.7299 139.082 66.0382 138.229 66.0382C137.376 66.0382 136.684 66.7299 136.684 67.5832C136.684 68.4365 137.376 69.1282 138.229 69.1282Z",
    fill: "url(#paint43_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.36 72.7979C136.034 72.7979 136.58 72.2519 136.58 71.5782C136.58 70.9046 136.034 70.3585 135.36 70.3585C134.687 70.3585 134.14 70.9046 134.14 71.5782C134.14 72.2519 134.687 72.7979 135.36 72.7979Z",
    fill: "url(#paint44_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M140.676 73.3369C141.082 73.3369 141.411 73.0077 141.411 72.6016C141.411 72.1955 141.082 71.8663 140.676 71.8663C140.27 71.8663 139.941 72.1955 139.941 72.6016C139.941 73.0077 140.27 73.3369 140.676 73.3369Z",
    fill: "url(#paint45_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.8063 58.1638C81.4368 58.1638 81.9478 57.6528 81.9478 57.0223C81.9478 56.3919 81.4368 55.8809 80.8063 55.8809C80.1759 55.8809 79.6649 56.3919 79.6649 57.0223C79.6649 57.6528 80.1759 58.1638 80.8063 58.1638Z",
    fill: "url(#paint46_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.7576 60.9253C79.2553 60.9253 79.6588 60.5218 79.6588 60.0241C79.6588 59.5264 79.2553 59.1229 78.7576 59.1229C78.2599 59.1229 77.8564 59.5264 77.8564 60.0241C77.8564 60.5218 78.2599 60.9253 78.7576 60.9253Z",
    fill: "url(#paint47_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.7028 61.2297C83.0029 61.2297 83.2461 60.9864 83.2461 60.6864C83.2461 60.3864 83.0029 60.1432 82.7028 60.1432C82.4028 60.1432 82.1596 60.3864 82.1596 60.6864C82.1596 60.9864 82.4028 61.2297 82.7028 61.2297Z",
    fill: "url(#paint48_linear_465_8205)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M65.9798 85.9128V97.7167C65.9798 107.578 88.4366 112.374 110.28 112.105L92.9342 94.7584C88.6151 90.094 78.1142 87.1461 65.9798 85.9128Z",
    fill: "url(#paint49_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0339 99.647H9.91797V132.27C9.91797 151.469 95.0339 151.469 95.0339 132.27V99.647Z",
    fill: "url(#paint50_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0339 99.647C95.0339 118.846 9.91797 118.846 9.91797 99.647C9.91797 80.4479 95.0339 80.4479 95.0339 99.647Z",
    fill: "url(#paint51_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2322 98.099C77.2322 101.215 71.4322 103.265 63.8025 104.248C49.1093 105.169 30.6605 104.088 30.6605 98.099C30.6605 94.7546 34.401 92.6384 42.8552 91.7514C48.8572 91.1214 55.7531 91.1108 61.7855 91.7193C63.8669 91.9293 65.549 92.684 67.3531 93.0414C69.8066 93.5275 72.2331 93.6793 73.8575 94.4384C75.9737 95.4272 77.2322 96.6475 77.2322 98.099Z",
    fill: "url(#paint52_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0243 92.2765C60.059 93.7024 55.7243 98.005 55.7243 103.092C55.7243 103.697 55.787 104.29 55.9049 104.869C67.0405 104.486 77.2325 102.229 77.2325 98.0988C77.2325 95.2936 72.5302 93.353 66.0243 92.2765Z",
    fill: "url(#paint53_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9074 104.234C62.8444 100.382 57.0033 97.4362 49.955 97.4362C43.4135 97.4362 37.9127 99.9741 36.3056 103.419C43.9112 105.106 55.1356 105.378 63.9074 104.234Z",
    fill: "url(#paint54_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7195 98.099C27.7195 101.362 34.0784 103.455 42.2384 104.379C45.8534 104.788 49.2037 102.142 49.4195 98.5105C49.4272 98.3814 49.431 98.2517 49.431 98.1214C49.431 97.4629 49.3322 96.8217 49.1451 96.2049C48.2569 93.2773 45.3078 91.4729 42.2681 91.8161C34.0937 92.7382 27.7195 94.8326 27.7195 98.099Z",
    fill: "url(#paint55_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7981 94.8265C61.2378 97.7353 64.7631 98.9262 67.6719 97.4865L73.8422 94.4323C71.0554 93.1338 66.7892 92.2353 61.9545 91.7368C60.2681 91.5629 59.0457 93.3068 59.7981 94.8265Z",
    fill: "url(#paint56_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.5588 98.5812C19.4121 98.5812 20.1038 97.8895 20.1038 97.0362C20.1038 96.1829 19.4121 95.4912 18.5588 95.4912C17.7055 95.4912 17.0138 96.1829 17.0138 97.0362C17.0138 97.8895 17.7055 98.5812 18.5588 98.5812Z",
    fill: "url(#paint57_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.7378 103.031C20.4114 103.031 20.9575 102.485 20.9575 101.811C20.9575 101.137 20.4114 100.591 19.7378 100.591C19.0641 100.591 18.5181 101.137 18.5181 101.811C18.5181 102.485 19.0641 103.031 19.7378 103.031Z",
    fill: "url(#paint58_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.9659 99.1648C24.372 99.1648 24.7012 98.8356 24.7012 98.4295C24.7012 98.0234 24.372 97.6942 23.9659 97.6942C23.5599 97.6942 23.2307 98.0234 23.2307 98.4295C23.2307 98.8356 23.5599 99.1648 23.9659 99.1648Z",
    fill: "url(#paint59_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.1667 103.681C83.02 103.681 83.7117 102.989 83.7117 102.136C83.7117 101.283 83.02 100.591 82.1667 100.591C81.3134 100.591 80.6217 101.283 80.6217 102.136C80.6217 102.989 81.3134 103.681 82.1667 103.681Z",
    fill: "url(#paint60_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M79.2983 107.351C79.9719 107.351 80.518 106.805 80.518 106.131C80.518 105.458 79.9719 104.911 79.2983 104.911C78.6247 104.911 78.0786 105.458 78.0786 106.131C78.0786 106.805 78.6247 107.351 79.2983 107.351Z",
    fill: "url(#paint61_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M84.6145 107.89C85.0206 107.89 85.3498 107.561 85.3498 107.155C85.3498 106.749 85.0206 106.419 84.6145 106.419C84.2084 106.419 83.8792 106.749 83.8792 107.155C83.8792 107.561 84.2084 107.89 84.6145 107.89Z",
    fill: "url(#paint62_linear_465_8205)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.7444 92.7168C25.3749 92.7168 25.8859 92.2057 25.8859 91.5753C25.8859 90.9449 25.3749 90.4338 24.7444 90.4338C24.114 90.4338 23.603 90.9449 23.603 91.5753C23.603 92.2057 24.114 92.7168 24.7444 92.7168Z",
    fill: "url(#paint63_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.6958 95.4783C23.1935 95.4783 23.597 95.0748 23.597 94.5771C23.597 94.0794 23.1935 93.6759 22.6958 93.6759C22.1981 93.6759 21.7946 94.0794 21.7946 94.5771C21.7946 95.0748 22.1981 95.4783 22.6958 95.4783Z",
    fill: "url(#paint64_linear_465_8205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.641 95.783C26.941 95.783 27.1842 95.5398 27.1842 95.2398C27.1842 94.9398 26.941 94.6965 26.641 94.6965C26.341 94.6965 26.0978 94.9398 26.0978 95.2398C26.0978 95.5398 26.341 95.783 26.641 95.783Z",
    fill: "url(#paint65_linear_465_8205)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_8205",
    x1: 95.9924,
    y1: 27.7583,
    x2: 115.592,
    y2: 48.5462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "#454518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    stopColor: "#443738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_8205",
    x1: 99.7485,
    y1: 4.94557,
    x2: 110.102,
    y2: 43.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_8205",
    x1: 105.552,
    y1: 16.7798,
    x2: 108.052,
    y2: 22.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_8205",
    x1: 114.798,
    y1: 12.075,
    x2: 121.122,
    y2: 19.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_8205",
    x1: 99.4071,
    y1: 8.16028,
    x2: 104.26,
    y2: 16.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_8205",
    x1: 87.4492,
    y1: 13.2123,
    x2: 93.6257,
    y2: 21.1534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_8205",
    x1: 113.031,
    y1: 20.3499,
    x2: 120.716,
    y2: 17.6999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_8205",
    x1: 71.4366,
    y1: 15.4572,
    x2: 64.1913,
    y2: 14.4622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_8205",
    x1: 72.1237,
    y1: 20.1656,
    x2: 66.4037,
    y2: 19.3799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_8205",
    x1: 75.6227,
    y1: 16.6843,
    x2: 72.1744,
    y2: 16.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_8205",
    x1: 133.877,
    y1: 22.468,
    x2: 129.929,
    y2: 16.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_8205",
    x1: 130.74,
    y1: 26.0482,
    x2: 127.623,
    y2: 21.1854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_8205",
    x1: 135.66,
    y1: 26.4505,
    x2: 133.782,
    y2: 23.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_8205",
    x1: 76.2848,
    y1: 11.3672,
    x2: 73.2595,
    y2: 6.88681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_8205",
    x1: 74.0312,
    y1: 14.0673,
    x2: 71.6429,
    y2: 10.5305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_8205",
    x1: 77.6734,
    y1: 14.2774,
    x2: 76.2337,
    y2: 12.1449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_8205",
    x1: 101.225,
    y1: 73.6964,
    x2: 66.6544,
    y2: 39.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#433244",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4841,
    stopColor: "#362637",
    stopOpacity: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_8205",
    x1: 36.4739,
    y1: 51.4398,
    x2: 56.0742,
    y2: 72.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "#454518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    stopColor: "#443738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_8205",
    x1: 40.231,
    y1: 28.6272,
    x2: 50.5845,
    y2: 67.3013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_8205",
    x1: 42.4311,
    y1: 43.1482,
    x2: 44.0488,
    y2: 48.5893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_8205",
    x1: 29.8911,
    y1: 37.4111,
    x2: 34.4499,
    y2: 45.9405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_8205",
    x1: 46.3453,
    y1: 34.9105,
    x2: 48.5512,
    y2: 39.6164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_8205",
    x1: 55.8212,
    y1: 36.804,
    x2: 60.8212,
    y2: 46.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_8205",
    x1: 28.2299,
    y1: 41.3493,
    x2: 30.877,
    y2: 46.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_8205",
    x1: 11.9048,
    y1: 39.1275,
    x2: 4.65945,
    y2: 38.1324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_8205",
    x1: 12.5921,
    y1: 43.836,
    x2: 6.87212,
    y2: 43.0504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_8205",
    x1: 16.091,
    y1: 40.3548,
    x2: 12.6427,
    y2: 39.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_8205",
    x1: 74.3314,
    y1: 46.1686,
    x2: 70.384,
    y2: 40.0087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_8205",
    x1: 71.1944,
    y1: 49.7488,
    x2: 68.0782,
    y2: 44.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_8205",
    x1: 76.1155,
    y1: 50.1511,
    x2: 74.2366,
    y2: 47.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_8205",
    x1: 16.7457,
    y1: 35.0785,
    x2: 13.7204,
    y2: 30.5981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_8205",
    x1: 14.4922,
    y1: 37.7786,
    x2: 12.1038,
    y2: 34.2419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_8205",
    x1: 18.1344,
    y1: 37.9887,
    x2: 16.6947,
    y2: 35.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_8205",
    x1: 101.358,
    y1: 75.1222,
    x2: 120.958,
    y2: 95.9101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "#454518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    stopColor: "#443738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_8205",
    x1: 105.115,
    y1: 52.3092,
    x2: 115.469,
    y2: 90.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_8205",
    x1: 107.589,
    y1: 57.4617,
    x2: 107.133,
    y2: 62.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_8205",
    x1: 92.7617,
    y1: 61.2953,
    x2: 96.7323,
    y2: 70.4129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_8205",
    x1: 109.204,
    y1: 64.0812,
    x2: 112.292,
    y2: 73.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_8205",
    x1: 121.452,
    y1: 62.7035,
    x2: 127.776,
    y2: 71.8212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_8205",
    x1: 118.397,
    y1: 59.3785,
    x2: 126.082,
    y2: 62.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_8205",
    x1: 76.7923,
    y1: 62.8286,
    x2: 69.5467,
    y2: 61.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_8205",
    x1: 77.4794,
    y1: 67.5369,
    x2: 71.7596,
    y2: 66.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_8205",
    x1: 80.9785,
    y1: 64.0559,
    x2: 77.53,
    y2: 63.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_8205",
    x1: 139.251,
    y1: 69.8557,
    x2: 135.304,
    y2: 63.6957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_8205",
    x1: 136.114,
    y1: 73.4359,
    x2: 132.998,
    y2: 68.5728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_8205",
    x1: 141.035,
    y1: 73.8378,
    x2: 139.156,
    y2: 70.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_8205",
    x1: 81.6682,
    y1: 58.752,
    x2: 78.6432,
    y2: 54.2716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_8205",
    x1: 79.4148,
    y1: 61.4524,
    x2: 77.0265,
    y2: 57.9154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_8205",
    x1: 83.0571,
    y1: 61.6622,
    x2: 81.617,
    y2: 59.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_8205",
    x1: 114.427,
    y1: 132.602,
    x2: 83.8801,
    y2: 102.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#433244",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4841,
    stopColor: "#362637",
    stopOpacity: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_8205",
    x1: 45.2965,
    y1: 109.675,
    x2: 64.8965,
    y2: 130.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "#454518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    stopColor: "#443738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_8205",
    x1: 49.0533,
    y1: 86.8623,
    x2: 59.4068,
    y2: 125.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_8205",
    x1: 53.4084,
    y1: 92.0108,
    x2: 53.8634,
    y2: 97.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_8205",
    x1: 65.539,
    y1: 96.7597,
    x2: 67.2137,
    y2: 104.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_8205",
    x1: 48.063,
    y1: 99.7938,
    x2: 53.2397,
    y2: 109.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_8205",
    x1: 38.7451,
    y1: 97.8135,
    x2: 43.8034,
    y2: 105.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_465_8205",
    x1: 62.3351,
    y1: 93.9315,
    x2: 70.0207,
    y2: 96.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_465_8205",
    x1: 20.7143,
    y1: 97.3728,
    x2: 13.4687,
    y2: 96.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_465_8205",
    x1: 21.4014,
    y1: 102.081,
    x2: 15.6816,
    y2: 101.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_465_8205",
    x1: 24.9005,
    y1: 98.6001,
    x2: 21.452,
    y2: 98.1263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_465_8205",
    x1: 83.1645,
    y1: 104.433,
    x2: 79.217,
    y2: 98.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_465_8205",
    x1: 80.0277,
    y1: 108.013,
    x2: 76.9113,
    y2: 103.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_465_8205",
    x1: 84.9489,
    y1: 108.415,
    x2: 83.07,
    y2: 105.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_465_8205",
    x1: 25.5901,
    y1: 93.3388,
    x2: 22.5648,
    y2: 88.8584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_465_8205",
    x1: 23.3365,
    y1: 96.0389,
    x2: 20.9482,
    y2: 92.5022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_465_8205",
    x1: 26.9788,
    y1: 96.249,
    x2: 25.539,
    y2: 94.1165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_8205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.621582)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategorySushi);
export default __webpack_public_path__ + "static/media/icon-category-sushi.597805dc.svg";
export { ForwardRef as ReactComponent };